export enum KbaResultEnum {
  VERIFICATION_FAIL = 'verification-fail',
  NO_MATCH = 'no-match',
  FILTERED_NO_MATCH = 'filtered-no-match',
  PARTIAL_MATCH = 'partial-match',
  FOUND = 'found',
  ERROR = 'error',
  CLIENT_NOT_FOUND = 'client-not-found',
  POSSIBLE_DUPLICATE_CLIENT = 'possible-duplicate-client',
  KBA_NOT_ANSWERED = 'kba-not-answered',
}
